'use strict';

var defineProperty = require('../../../node_modules/@babel/runtime/helpers/defineProperty.js');
var slicedToArray = require('../../../node_modules/@babel/runtime/helpers/slicedToArray.js');
var React = require('react');
var LeftNavigationContext = require('./LeftNavigationContext.js');
var LeftNavigationIndicator = require('./LeftNavigationIndicator.js');
var makeStyles = require('../../Styles/makeStyles.js');
var Slide = require('../../../node_modules/@material-ui/core/esm/Slide/Slide.js');
var List = require('../../../node_modules/@material-ui/core/esm/List/List.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var INDICATOR_HEIGHT = 16;
var LIST_ITEM_HEIGHT = 40;
var offsetToVerticallySet = (LIST_ITEM_HEIGHT - INDICATOR_HEIGHT) / 2;
var useStyles = makeStyles["default"](function () {
  return {
    wrapper: {
      position: 'relative'
    }
  };
});

var LeftNavigationUsingList = function LeftNavigationUsingList(_ref) {
  var children = _ref.children,
      onTabChange = _ref.onTabChange,
      tabValue = _ref.tabValue,
      onSlideOpen = _ref.onSlideOpen,
      SlideProps = _ref.SlideProps;

  var _useLeftNavigationCon = LeftNavigationContext.useLeftNavigationContext(),
      startingYPosition = _useLeftNavigationCon.startingYPosition,
      collapsableState = _useLeftNavigationCon.collapsableState,
      setTabValue = _useLeftNavigationCon.setTabValue;

  var _useState = React.useState(0),
      _useState2 = slicedToArray(_useState, 2),
      verticalStartingPosition = _useState2[0],
      setVerticalStartingPosition = _useState2[1];

  var _useStyles = useStyles(),
      wrapper = _useStyles.wrapper;

  var listRef = React.useRef(null);
  React.useEffect(function () {
    if (listRef === null || listRef === void 0 ? void 0 : listRef.current) {
      var _listRef$current;

      var distanceFromTop = (_listRef$current = listRef.current) === null || _listRef$current === void 0 ? void 0 : _listRef$current.getBoundingClientRect().top;
      var totalDistance = startingYPosition - distanceFromTop + offsetToVerticallySet;
      setVerticalStartingPosition(totalDistance);
    }
  }, [startingYPosition, listRef, collapsableState]);

  var handleTabChange = function handleTabChange(event, value) {
    setTabValue(value);
    onTabChange && onTabChange(event, value);
  };

  var childIsAGroupItem = function childIsAGroupItem(child) {
    return !child['props'].value;
  };

  var isSelected = function isSelected(child) {
    return child['props'].value === tabValue;
  };

  var listItemChild = function listItemChild(child) {
    return React__default["default"].cloneElement(child, _objectSpread({
      handleTabChange: handleTabChange
    }, childIsAGroupItem(child) ? {} : {
      selected: isSelected(child)
    }));
  };

  return React__default["default"].createElement(Slide["default"], _objectSpread({
    direction: "right",
    "in": onSlideOpen
  }, SlideProps), React__default["default"].createElement(List["default"], {
    disablePadding: true,
    className: wrapper,
    ref: listRef
  }, React__default["default"].Children.map(children, function (child) {
    if (React.isValidElement(child)) return listItemChild(child);
  }), React__default["default"].createElement(LeftNavigationIndicator, {
    verticalStartingPosition: verticalStartingPosition
  })));
};

module.exports = LeftNavigationUsingList;
